/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { StudentResumeeFinancialPerson } from "../types/StudentResumeeFinancialPerson.ts";

export const studentResumeeFinancialPersonSchema = z.object({
  courseFinancialPersonId: z.optional(
    z.number().int().describe("ID do responsável financeiro do curso."),
  ),
  courseFinancialName: z
    .string()
    .describe("Nome do responsável financeiro.")
    .nullish(),
  isMain: z.optional(
    z
      .boolean()
      .describe("Indica se este é o responsável financeiro principal."),
  ),
  totalParcels: z.optional(
    z.number().int().describe("Total de parcelas do contrato financeiro."),
  ),
  paidParcels: z.optional(
    z.number().int().describe("Número de parcelas já pagas."),
  ),
  valueTotalParcels: z.optional(
    z.number().describe("Valor total das parcelas do contrato."),
  ),
  valuePaidParcels: z.optional(
    z.number().describe("Valor total das parcelas já pagas."),
  ),
  paymentMethod: z.optional(
    z
      .number()
      .int()
      .describe("Código do método de pagamento do responsável financeiro."),
  ),
  disableWarnings: z
    .array(z.string())
    .describe("Lista de avisos desativados para este responsável financeiro.")
    .nullish(),
  creationDate: z
    .string()
    .datetime()
    .describe("Data de criação do registro. Opcional.")
    .nullish(),
  lastChangeDate: z
    .string()
    .datetime()
    .describe("Data da última alteração do registro. Opcional.")
    .nullish(),
  userCreation: z
    .string()
    .describe("Usuário responsável pela criação do registro.")
    .nullish(),
  userLastChange: z
    .string()
    .describe("Usuário responsável pela última alteração do registro.")
    .nullish(),
}) as unknown as ToZod<StudentResumeeFinancialPerson>;
